import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="bg-cream py-10 sm:py-14" data-id="element-23" data-mp="1hig2vkby5gjo">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-24" data-mp="1clzd6lp3mu4h">
        <SectionTag icon="✓" data-id="element-25" data-mp="18k4d1kiwmmsa">+ 6 Bonos Premium</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-26" data-mp="18hhtsnmniiu8">
          Para Implementación
        </h2>
        <p className="mt-3 text-base text-muted sm:text-lg" data-id="element-27" data-mp="20ailh185f6wk">
          Valor: <span className="font-semibold text-navy line-through" data-id="element-28" data-mp="1w95cwjdo8ply">120€</span>
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-4xl gap-4 px-4 sm:px-6" data-id="element-29" data-mp="1ra2jjw7207tt">
        {bonuses.map((bonus, i) => <m.div key={bonus.title} initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.05
      }} className="flex flex-col gap-4 rounded-2xl border border-navy/10 bg-white p-6 sm:flex-row sm:items-start" data-id="element-30" data-mp="ktqfjehjvvqb" data-mpi={i}>
            <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-orange/10" data-id="element-31" data-mp="1jqnfqen266bs">
              <bonus.icon size={22} className="text-orange-hover" data-id="element-32" data-mp="1as1rc2uwnx33" />
            </div>
            <div className="flex-1" data-id="element-33" data-mp="1au64lbep28g1">
              <div className="flex flex-wrap items-baseline justify-between gap-2" data-id="element-34" data-mp="w2nfmo3ux3kj">
                <h3 className="font-heading text-base font-semibold text-navy sm:text-lg" data-id="element-35" data-mp="10tlzfxo20jsj">{bonus.title}</h3>
                <span className="text-sm text-muted" data-id="element-36" data-mp="n30qb0oejo7u">{bonus.pages}</span>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-37" data-mp="r3szxv16rv4n">{bonus.text}</p>
            </div>
          </m.div>)}
      </div>
    </section>;
}